module.exports = __webpack_public_path__ + "img/lemon-left-3.84a54437.png";